let modals = require( './modals' );

let vibe_cake_masters_quiz_complete_modal = function( $ ) {

	let $modal;

	let _init = function() {
		$modal = $( '#masters-modal-quiz-complete' );

		if ( $modal.length > 0 ) {
			_show_modal();
		}
	};

	let _show_modal = function() {
		modals.open_modal( $modal );
	};

	$( document ).ready( _init );

} ( jQuery );

module.exports = vibe_cake_masters_quiz_complete_modal;